import React from "react";
import { getEngine, getDevStatus } from "@/lib/engines";

/**
 * Compact F95Zone-style metadata badges for TL game posts.
 * Engine + dev status are first-class metadata, never tags.
 *
 * Used consistently across:
 *   • Homepage cards
 *   • Posts listing cards
 *   • Post detail page
 *   • Search results
 */
export default function MetaBadges({ engine, dev_status, size = "sm", className = "" }) {
  const eng = getEngine(engine);
  const st = getDevStatus(dev_status);
  const sizeClass =
    size === "md"
      ? "text-[11px] px-2 py-0.5"
      : "text-[10px] px-1.5 py-0.5";
  return (
    <div className={`inline-flex flex-wrap items-center gap-1.5 ${className}`}>
      <span
        data-testid={`badge-engine-${eng.value}`}
        className={`${sizeClass} rounded font-semibold uppercase tracking-wider ${eng.chip}`}
      >
        {eng.label}
      </span>
      <span
        data-testid={`badge-status-${st.value}`}
        className={`${sizeClass} rounded font-semibold uppercase tracking-wider ${st.chip}`}
      >
        {st.label}
      </span>
    </div>
  );
}
